/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevertEmailData
 */
export interface RevertEmailData {
    /**
     * 
     * @type {string}
     * @memberof RevertEmailData
     */
    token: string;
}

/**
 * Check if a given object implements the RevertEmailData interface.
 */
export function instanceOfRevertEmailData(value: object): value is RevertEmailData {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function RevertEmailDataFromJSON(json: any): RevertEmailData {
    return RevertEmailDataFromJSONTyped(json, false);
}

export function RevertEmailDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevertEmailData {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

  export function RevertEmailDataToJSON(json: any): RevertEmailData {
      return RevertEmailDataToJSONTyped(json, false);
  }

  export function RevertEmailDataToJSONTyped(value?: RevertEmailData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
    };
}

